import { createContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { usersActions, usersSelectors } from 'modules/users';
import notifications from 'modules/notifications';
import { formatDateToApi } from 'core/utils/formatters';
import { sessionActions, sessionSelectors } from 'modules/session';

export const ProfileContext = createContext();

export default () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const loading = useSelector((state) => usersSelectors.getLoading(state));
  const user = useSelector((state) => sessionSelectors.getUser(state));
  const [dates, setDates] = useState();
  const [formData, setFormData] = useState({ description: '', date: null });

  const save = () => {
    const date = formData.date ? formatDateToApi(formData.date) : null;

    if (!date) {
      dispatch(notifications.error(t('validation.coach.date')));
      return;
    }
    const currentDates =
      user?.coachesUnavailableDates?.map((x) => ({
        id: x.id,
        date: x.date,
        description: x.description,
      })) || [];
    const coachesUnavailableDatesAttributes = [
      ...currentDates,
      {
        date,
        description: formData.description,
      },
    ];

    dispatch(
      usersActions.putUpdateUserStart(
        {
          id: user.id,
          user: {
            coachesUnavailableDatesAttributes,
          },
        },
        () => {
          dispatch(sessionActions.authenticateStart());
          setFormData({});
          dispatch(notifications.success(t('message.success.save.profile')));
        },
      ),
    );
  };

  const remove = (id) => {
    dispatch(
      usersActions.putUpdateUserStart(
        {
          id: user.id,
          user: {
            coachesUnavailableDatesAttributes: [{ id, _destroy: true }],
          },
        },
        () => {
          dispatch(sessionActions.authenticateStart());
          dispatch(notifications.success(t('message.success.save.profile')));
        },
      ),
    );
  };

  return {
    save,
    dates,
    setDates,
    loading,
    user,
    formData,
    setFormData,
    remove,
    coachesUnavailableDates: user?.coachesUnavailableDates,
  };
};
